import { render, staticRenderFns } from "./editInduction.vue?vue&type=template&id=ca783b36&scoped=true"
import script from "./editInduction.vue?vue&type=script&lang=js"
export * from "./editInduction.vue?vue&type=script&lang=js"
import style0 from "./editInduction.vue?vue&type=style&index=0&id=ca783b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca783b36",
  null
  
)

export default component.exports